/**
 * login模块api
 */

import request from './request';

// export function getUserInfo() {
//     return request('/gaia/api/admin/user/info', { method: 'GET', });
// }

export function getUserInfo(params) {
    return request('/user/info/after-login', {
        method: 'GET',
        params,
    });
}

// 查询用户拥有的菜单权限树
export function getUserMenu(params) {
    // const URL = process.env.NODE_ENV === 'development' ? '/gaia/saas/menu/user/tree' : '/menu/user/tree';
    // return request(URL, {
    //     method: 'GET',
    //     params,
    // });
    return request('/menu/user/tree', {
        method: 'GET',
        params,
    });
}

export function logOut() {
    return request('/user/logout', { method: 'GET' });
}

// 获取图形验证码
export function getCaptcha() {
    return request('/auth_service/api/captcha/', {
        method: 'GET',
    });
}
// 获取手机验证码
export function getThpCode(params) {
    return request('/auth_service/api/verify_code/', {
        method: 'POST',
        params,
    });
}
// 手机验证码登录
export function loginByPhone(params) {
    return request('/user/login/phone', {
        method: 'POST',
        params,
    });
}
// 用户名密码登录
export function loginByUsername(params) {
    return request('/user/login/username', {
        method: 'POST',
        params,
    });
}

// 设置密码
export function setPassword(params) {
    return request('/user/set-password', {
        method: 'POST',
        params,
    });
}

// 重置密码
export function resetPassword(params) {
    return request('/user/reset-password', {
        method: 'PATCH',
        params,
    });
}

// 修改手机号
export function modifyPhone(params) {
    return request('/user/phone', {
        method: 'PATCH',
        params,
    });
}

// 获取单店、集团下拉数据
export function getUserOrg(params) {
    return request('/user/user-org', {
        method: 'GET',
        params,
    });
}

// 选店提交
export function checkOrg(params) {
    return request('/user/check-org', {
        method: 'PATCH',
        params,
    });
}

// 修改用户姓名
export function modifyName(params) {
    return request('/user/name', {
        method: 'PATCH',
        params,
    });
}

// 获取客户数
export function getCustomerCount() {
    return request('/customer/all-count', {
        method: 'GET',
    });
}

// 获取扫码登录二维码
export function getLoginQrcode(params) {
    return request('/user/login/qrcode', {
        method: 'GET',
        params,
    });
}

// 检查扫码登录二维码的状态
export function checkQrcode(params) {
    return request('/user/login/qrcode/check', {
        method: 'GET',
        params,
    });
}
